import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
  AllocationPayload,
  create,
  getAll,
  getById,
  remove,
  update,
} from '@/repositories/beneva-api/endpoints/allocations';

export const useAllocations = () => {
  return useQuery({
    queryKey: ['allocations'],
    queryFn: () => {
      return getAll();
    },
  });
};

export const useAllocation = (allocationId: string) => {
  return useQuery({
    queryKey: ['allocations', allocationId],
    queryFn: () => {
      return getById(allocationId);
    },
  });
};

export const useCreateAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (newAllocation: AllocationPayload) => {
      return create(newAllocation);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['allocations']});
    },
  });
};

export const useUpdateAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({allocationId, updatedAllocation}: {allocationId: string; updatedAllocation: AllocationPayload}) => {
      return update(allocationId, updatedAllocation);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['allocations']});
    },
  });
};

export const useDeleteAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (allocationId: string) => {
      return remove(allocationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['allocations']});
    },
  });
};
